<template>
  <modal class="remark-modal">
    <h2 class="font-bold">Reden van afkeuring</h2>
    <p class="modal-body-text">{{remarkCustomer}}</p>
  </modal>
</template>
<script lang="ts" setup>
import Modal from '@app/components/Modal.vue';

defineProps<{
  remarkCustomer: string,
}>();

</script>
<style lang="scss">
.remark-modal {
  display: flex;
  flex-direction: column;

    .modal-body {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      overflow: hidden;

      .modal-body-text {
        flex: 1 1 auto;
        overflow-y: scroll;
      }
    }

}
</style>
